module.exports = __webpack_public_path__ + "static/img/shop.f27dd0f2.png";